export enum ProfileFilterTypeEnum {
  PROFILE = 'PROFILE'
}
